@if (visible) {
  <div [formGroup]="element.group"
    class="form-group"
    [ngClass]="element?.theme?.outerWrap"
    >
    @if (element?.elementOptions?.label) {
      <label [ngClass]="element?.theme?.labelClass">{{ element?.elementOptions?.label | translate }}
        @if (element.validations?.required) {
          <b style="color:red">*</b>
        }
        @if (element?.tooltip?.display) {
          <span>
            <i class="fa fa-question-circle" aria-hidden="true" placement="{{element.tooltip.placement || 'right'}}" ngbTooltip="{{element.tooltip.text}}"></i>
          </span>
        } : </label>
      }
      @for (option of element?.elementOptions?.options; track option; let i = $index) {
        <div [ngClass]="element?.theme?.alignmentClass">
          <div [ngClass]="element?.theme?.sampleClass" class="wrapper wrapper-radio mb-3">
            <input
              [id]="element?.id + '-' + i"
              [name]="element?.name"
              type="radio"
              [ngClass]="element?.theme?.control"
              [formControlName]="element.name"
              [value]="option.value"
              [attr.disabled]="option.disabled === true ? true : null">
              <label [for]="element?.id + '-' + i" [ngClass]="element?.theme?.childLabel">{{ option.label | translate }}</label>
            </div>
          </div>
        }
        @if (element.group.controls[this.element['name']].dirty && !element.group.controls[this.element['name']].pristine && (element.group.controls[this.element['name']].status === 'INVALID')) {
          <div class="alert alert-danger" role="alert">
            <rs-error-message [fieldForm]="element.group.controls[this.element['name']]" [field]="element"></rs-error-message>
          </div>
        }
      </div>
    }
